/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Clear_Text_TextInputs */



/**
* | output |
* | --- |
* | "This will clear the text of the selected Events." |
*
* @param {Shortcut_Keys_Clear_Text_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_clear_text_text = /** @type {((inputs?: Shortcut_Keys_Clear_Text_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Clear_Text_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ceci effacera le texte des evenements selectionnes.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dadurch wird der Text der ausgewählten Ereignisse gelöscht.")
	if (locale === "it") return /** @type {LocalizedString} */ ("In questo modo verrà cancellato il testo degli eventi selezionati.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Это очистит текст выбранных событий.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Esto borrará el texto de los eventos seleccionados.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("这将清除所选事件的文本。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("これにより、選択したイベントのテキストがクリアされます。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इससे चयनित इवेंट्स का टेक्स्ट हट जाएगा।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Isso limpará o texto dos eventos selecionados.")
	return /** @type {LocalizedString} */ ("This will clear the text of the selected Events.")
});